export var passwordErrorMessageMixin = {
	computed: {
		passwordErrorMessage: function passwordErrorMessage() {
			var propertyName = 'password';

			return [!this.$v[propertyName].$dirty || this.$v[propertyName].required || 'Debes ingresar una contraseña', !this.$v[propertyName].$dirty || this.$v[propertyName].minLength || 'Debes ingresar minimo 6 caracteres'].filter(function (val) {
				return typeof val === 'string';
			});
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/mixins/password-error-messages.js
// module id = ./src/mixins/password-error-messages.js
// module chunks = 34